import { FC, ReactNode } from 'react'

import { Tooltip } from '../Tooltip/Tooltip'
import * as S from './TextCombination.styles'

interface TextCombinationProps {
  text: string
  subText?: string
  textTooltip?: string | ReactNode
  textColor?: string
  subTextColor?: string
  fullWidth?: boolean
}

export const TextCombination: FC<TextCombinationProps> = ({
  text,
  subText,
  textTooltip,
  textColor,
  subTextColor,
  fullWidth,
}) => (
  <S.Container fullWidth={fullWidth}>
    <Tooltip content={textTooltip} placement="top" disabled={!textTooltip}>
      <S.Text textColor={textColor}>{text}</S.Text>
    </Tooltip>
    {subText ? <S.SubText subTextColor={subTextColor}>{subText}</S.SubText> : null}
  </S.Container>
)
